import { useState } from 'react';
import { Typography } from '@/shared/ui/Typography';
import { classNames } from '@/shared/lib/classNames';
import cls from './Disclaimer.module.scss';

type Props = {
    className?: string;
    hideStar?: boolean;
    hideUnderButton?: boolean;
};

export const Disclaimer = ({ className, hideStar = false, hideUnderButton = false }: Props) => {
    const [isHidden, setIsHidden] = useState(hideUnderButton);

    if (isHidden) {
        return (
            <Typography
                className={cls.showButton}
                as="button"
                type="button"
                variant="text_16_gray"
                onClick={() => setIsHidden(false)}
            >
                Дисклеймер
            </Typography>
        );
    }

    return (
        <article className={classNames(cls.container, {}, [className])}>
            <Typography as="p" variant="text_16_gray">
                {!hideStar && '*'}Договор страхования не является договором банковского вклада, и денежные средства по нему не
                подлежат обязательному страхованию в&nbsp;соответствии&nbsp;с&nbsp;Законом от 23.12.2003 г. № 177-ФЗ «О
                страховании вкладов физических лиц в банках Российской Федерации». Договор страхования не&nbsp;является
                инвестиционным договором. Договор страхования не является производным финансовым инструментом в соответствии с ФЗ
                от 22.04.1996 №&nbsp;
                <span className="nowrap">39-ФЗ</span>&nbsp;«О рынке ценных бумаг». Страховые премии с момента внесения их по
                договору страхования не являются собственными средствами страхователей. В программе не предусмотрена защита
                капитала.
            </Typography>
            <Typography as="p" variant="text_16_gray">
                Страховые услуги оказывает ООО СК «СберБанк Страхование жизни». Лицензии на осуществление страхования:
                СЖ&nbsp;№&nbsp;3692 (вид деятельности — добровольное страхование жизни) и СЛ № 3692 (вид деятельности —
                добровольное личное страхование, за исключением добровольного страхования жизни), выданы Банком России без
                ограничения срока действия. С правилами страхования вы можете ознакомиться на сайте страховщика:&nbsp;
                <Typography className="nowrap" as="a" variant="link" target="_blank" href="https://sberbank-insurance.ru/">
                    www.sberbank-insurance.ru
                </Typography>
                .
            </Typography>
            <Typography as="p" variant="text_16_gray">
                ПАО Сбербанк выступает агентом страховой компании на основании агентского договора.
            </Typography>
            <Typography as="p" variant="text_16_gray">
                Под термином «капитал» в данном информационном сообщении понимается размер внесённых страховых взносов
                по&nbsp;договору страхования.
            </Typography>
            <Typography as="p" variant="text_16_gray">
                Указанная информация носит информационный характер и не является публичной офертой.
            </Typography>
            <Typography as="p" variant="text_16_gray">
                Инвестиционные цели представляют собой экспертную оценку Страховщика и&nbsp;не&nbsp;являются обещаниями
                (или)&nbsp;гарантией дохода, сохранности внесенных денежных средств. Результаты инвестирования в&nbsp;прошлом
                не&nbsp;определяют доходов в&nbsp;будущем. Данная информация не&nbsp;является индивидуальной инвестиционной
                рекомендацией, и&nbsp;финансовые инструменты либо операции, упомянутые в&nbsp;ней, могут не&nbsp;соответствовать
                вашему инвестиционному профилю и&nbsp;инвестиционным целям (ожиданиям). Определение соответствия финансового
                инструмента либо операции вашим интересам, инвестиционным целям, инвестиционному горизонту и&nbsp;уровню
                допустимого риска является вашей задачей. Страховщик не&nbsp;несет ответственности за&nbsp;возможные убытки
                в&nbsp;случае совершения операций либо инвестирования в&nbsp;финансовые инструменты, упомянутые в&nbsp;данной
                информации, и&nbsp;не&nbsp;рекомендует использовать указанную информацию в&nbsp;качестве единственного источника
                информации при&nbsp;принятии инвестиционного решения.
            </Typography>
            <Typography as="p" variant="text_16_gray">
                Программа страхования «Квадратные метры» может иметь название «Капитал под управлением».
            </Typography>
        </article>
    );
};
